import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { jsPDFDocument, RowInput, Styles } from "jspdf-autotable";

import { OrderPaymentMethod, OrderPaymentMethods } from "../../constants";
import { OrderDetails } from "../../orders.types";

interface renderPaymentProps {
  pdf: jsPDF;
  orderDetails: OrderDetails;
  normalFontStyles: Partial<Styles>;
  bigFontStyles: Partial<Styles>;
}

export const renderPayment = ({
  pdf,
  orderDetails,
  normalFontStyles,
  bigFontStyles
}: renderPaymentProps) => {
  const orderPayment =
    orderDetails?.paymentMethod &&
    OrderPaymentMethods[orderDetails.paymentMethod];

  const orderTotal = orderDetails.totalOrder;

  const body: RowInput[] = [
    [
      {
        content: t(orderPayment?.label),
        styles: {
          valign: "middle",
          halign: "left",
          ...normalFontStyles,
          cellPadding: { top: 1, horizontal: 5 }
        }
      },
      {
        content: `${t("Order Total")}: ${orderTotal?.toLocaleString("en-US")} FCFA`,
        styles: {
          valign: "middle",
          halign: "right",
          ...bigFontStyles,
          cellPadding: { top: 1, horizontal: 5 }
        }
      }
    ]
  ];

  if (orderDetails.paymentMethod !== OrderPaymentMethod.CashOnDelivery) {
    body.push([
      null,
      {
        content: `${t("TOTAL TO COLLECT FROM THE CUSTOMER")}: 0 FCFA`,
        styles: {
          ...normalFontStyles,
          valign: "middle",
          halign: "right",
          cellPadding: { horizontal: 5 }
        }
      }
    ]);
  }

  autoTable(pdf, {
    theme: "plain",
    startY: (pdf as jsPDFDocument).lastAutoTable.finalY ?? 80,
    styles: { cellPadding: 5 },
    head: [
      [
        {
          content: t("Payment Method"),
          styles: {
            valign: "middle",
            halign: "left",
            ...normalFontStyles,
            cellPadding: { top: 5, bottom: 1, horizontal: 5 }
          }
        },
        {
          content: `${t("Delivery Fee")}: ${orderDetails?.deliveryFee?.toLocaleString("en-US")} FCFA`,
          styles: {
            valign: "middle",
            halign: "right",
            ...normalFontStyles,
            cellPadding: { top: 5, bottom: 1, horizontal: 5 }
          }
        }
      ]
    ],
    body,
    tableLineWidth: 1,
    tableLineColor: "#000000"
  });
};
